import logo from '../assets/images/logo.svg';

export default function Logo(params) {
  return <img src={logo} alt="jobster logo" className="logo" />;
}
